import  { Fragment, useEffect, useState } from 'react'
import Avatar from "../images/avatar.png"
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../loader/loader'
import { UpdateRoleAction } from '../../redux/actions/userActions'

const SingleUser = ({ user }) => {


    const dispatch = useDispatch()

    const { loading, message } = useSelector((state) => state.updateRole)



    const [userRole, setuserRole] = useState(user?.role)
    const [isChange, setIsChange] = useState(false)



    useEffect(() => {

        if (userRole && userRole !== user.role) {
            setIsChange(true)
        }

    }, [userRole, user])



    useEffect(() => {


        if (message) {
            setIsChange(false)
        }

    }, [dispatch, message])


    const handleRoleChange = () => {
        dispatch(UpdateRoleAction({ id: user.id, role: userRole }))
    }


    return (
        <Fragment>
            {loading && <Loader />}
            <div className="bg-white p-[1vmax] shadow-1 w-[100%] lg:w-[32%] rounded-[1vmax]">
                <div className="flex gap-[1vmax] items-center">
                    <div className="w-[4vmax] ">
                        <img src={user.avatar_url || Avatar} alt="" className='h-[4vmax] rounded-[50%]' />
                    </div>
                    <div className="">
                        <h3 className='text-[1.3vmax] font-bold capitalize' >
                            {user?.name}
                            <br />
                            <span className={`text-[0.9vmax] font-[600] px-[0.5vmax] rounded-[1vmax] border-[0.14vmax] 
                            ${user.role === 'Admin' ?
                                    'border-green-500  text-green-500 bg-green-100'
                                    :

                                    user.role === 'Unauthorized' ?
                                        'border-red-500  text-red-500 bg-red-100'
                                        :
                                        'border-[var(--color-2)]  text-[var(--color-2)] bg-[var(--color-2-light)]'

                                }
                            `} >{user?.role}</span>
                        </h3>
                        <span className='text-gray-500 text-[0.9vmax]' >{user?.email}</span>

                    </div>
                </div>
                <div className='flex flex-col mt-[1vmax] relative'>
                    <select
                        value={userRole}
                        onChange={(e) => setuserRole(e.target.value)}
                        className='border-[0.15vmax] px-[2vmax] py-[0.7vmax] rounded-[2vmax] mt-[0.7vmax] outline-blue-400 bg-blue-50'
                    >
                        <option value="Admin">Admin</option>
                        <option value="Unit Admin">Unit Admin</option>
                        <option value="Unauthorized">Unauthorized</option>
                    </select>
                    <button className={`absolute top-[0.8vmax] right-0
                             px-[1.3vmax] h-[80%] rounded-[2vmax] font-bold text-white ${isChange ? 'bg-[image:var(--gradient-2)]' : 'bg-gray-400 cursor-not-allowed'}
                            `} disabled={!isChange}
                        onClick={() => handleRoleChange()}
                    >Change</button>
                </div>
            </div>
        </Fragment>
    )
}

export default SingleUser